import { render, staticRenderFns } from "./BloodPressureMonitors.vue?vue&type=template&id=3f2d2857"
import script from "./BloodPressureMonitors.vue?vue&type=script&lang=js"
export * from "./BloodPressureMonitors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports